import React from "react";
import { Grid } from "components/src/components/Grid/Grid";

export const ColumnLayout = ({ mappedMarkets }) => {
    return <Grid columns={2} flush>
    {mappedMarkets}
  </Grid>
}